/* Common Imports */
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

/* Component Imports */
import {
  Button,
  Checkbox,
  FormControlLabel,
  Link,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  TextField,
} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import AppConfig from "../../../../AppConfig";
import sendToGoogleSheets from "../../../../lib/sendToGoogleSheets";

/* Data Imports */

const useStyles = makeStyles((theme) => ({
  contactPaper: {
    padding: "2rem 1.5rem 2rem 1.5rem",
    width: "42%",
    [theme.breakpoints.only("md")]: {
      width: "100%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      margin: "0.5rem 0rem 0rem 0rem",
    },
    borderRadius: "1rem",
  },
  contactForm: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "space-between",
    width: "100%",
  },
  textField: {
    margin: "0rem 0rem 1.125rem 0rem",
    width: "100%",
  },
  checkboxRow: {
    padding: "0rem 0rem 2rem 0.5rem",
    height: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    [theme.breakpoints.up("lg")]: {
      alignItems: "center",
    },
  },
  grey: {
    color: "#212121",
  },
  btnRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-end",
    },
    alignItems: "flex-end",
  },
  buttons: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "felx-end",
    width: "100%",
    gap: "2rem",
    [theme.breakpoints.down("xs")]: {
      margin: "2rem 0rem 0rem 0rem",
    },
  },
  primaryButton: {
    background: "linear-gradient(to right, #0FCA56 0%, #08A945 100%)",
    color: "#FFFFFF",
    borderRadius: "1rem",
    borderWidth: "0px",
    fontSize: "1.3rem",
    fontWeight: "500",
    textTransform: "none",
    width: "40%",
    boxShadow: "none",
    "&:hover": {
      background: "linear-gradient(to right, #0FCA56 0%, #08A945 100%)",
      textDecoration: "underline",
      textUnderlineOffset: "3px",
      boxShadow: "none",
    },
    "&:disabled": {
      background: "#ececec",
      color: "##88888a",
      border: "solid 1px #ececec",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
      width: "100%",
    },
    [theme.breakpoints.down("lg")]: {
      width: "55%",
    },
  },
  btnIcon: {
    marginLeft: "1rem",
  },
  textforms: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: "0.25rem",
  },
  phoneContainer: {
    display: "flex",
    gap: "0.5rem",
    width: "100%",
    marginBottom: "1.125rem",
  },
  countryCode: {
    minWidth: "120px",
    "& .MuiSelect-select": {
      backgroundColor: "#FFFFFF",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "1rem",
    },
  },
  phoneInput: {
    flex: 1,
  },
}));

function Alert(props) {
  return (
    <MuiAlert
      elevation={6}
      variant="filled"
      {...props}
    />
  );
}

const ContactForm = (props) => {
  const classes = useStyles();

  const [loadingSnackbar, setLoadingSnackbar] = React.useState(false);
  const [successSnackbar, setSuccessSnackbar] = React.useState(false);
  const [errorSnackbar, setErrorSnackbar] = React.useState(false);
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  //   const [message, setMessage] = React.useState("");
  const [atc, setAtc] = React.useState(false);
  const [btnDisabled, setBtnDisabled] = React.useState(true);
  const [countryCode, setCountryCode] = React.useState("+91");

  // Add this validation object
  const phonePatterns = {
    "+91": {
      pattern: /^[6-9]\d{9}$/,
      maxLength: 10,
      errorText: "Please enter a valid Indian mobile number starting with 6, 7, 8, or 9",
    },
    "+65": {
      pattern: /^[689]\d{7}$/,
      maxLength: 8,
      errorText: "Please enter a valid Singapore mobile number starting with 6, 8, or 9",
    },
    "+971": {
      pattern: /^[5]\d{8}$/,
      maxLength: 9,
      errorText: "Please enter a valid UAE mobile number starting with 5",
    },
    "+1": {
      pattern: /^[2-9]\d{9}$/,
      maxLength: 10,
      errorText: "Please enter a valid US mobile number starting with 2-9",
    },
  };

  // Add these validation functions
  const validatePhone = (phoneNumber) => {
    if (!phoneNumber) return false;
    const validation = phonePatterns[countryCode];
    if (!validation) return false;
    if (phoneNumber.length !== validation.maxLength) return false;
    return validation.pattern.test(phoneNumber);
  };

  const getErrorText = () => {
    if (phone === "") return "";
    const validation = phonePatterns[countryCode];
    if (!validation) return "Invalid country code";
    if (phone.length !== validation.maxLength) {
      return `Please enter exactly ${validation.maxLength} digits`;
    }
    return validation.errorText;
  };

  React.useEffect(() => {
    if (
      name !== (undefined || "") &&
      phone !== (undefined || "") &&
      validatePhone(phone) &&
      email !== (undefined || "") &&
      email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i) &&
      atc === true
    ) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
  }, [name, phone, email, atc, countryCode]);

  const submitForm = () => {
    let reqURL =
      AppConfig.apiUrlPrefix +
      "contact?name=" +
      name +
      "&email=" +
      email +
      "&countryCode=" +
      countryCode +
      "&phone=" +
      phone +
      "&atc=" +
      atc +
      "&source=" +
      (props.source ? props.source : "unknown");

    // if (message) {
    //   reqURL += "&message=" + message;
    // }

    reqURL = encodeURI(reqURL);
    console.log(reqURL, "Request URL");

    setBtnDisabled(true);
    setLoadingSnackbar(true);
    fetch(reqURL, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        res
          .json()
          .then((data) => {
            console.log(data);
            if (data.status === "success") {
              setLoadingSnackbar(false);
              setSuccessSnackbar(true);
              // Keep button disabled after success

              // Send to Google Sheets
              sendToGoogleSheets({
                name: name,
                email: email,
                countryCode: countryCode,
                phone: phone,
                source: props.source || "Contact Form",
                type: "contact",
              })
                .then((result) => {
                  console.log("Google Sheets result:", result);
                })
                .catch((err) => {
                  console.error("Google Sheets error:", err);
                });

              // Add URL parameter for Google Ads tracking when submitted from Eden or Halcyon page
              if (typeof window !== "undefined") {
                if (props.source === "Heavie Eden") {
                  const currentUrl = new URL(window.location.href);
                  currentUrl.searchParams.set("form_submitted", "eden");
                  window.history.pushState({}, "", currentUrl.toString());
                } else if (props.source === "Heavie Halcyon") {
                  const currentUrl = new URL(window.location.href);
                  currentUrl.searchParams.set("form_submitted", "halcyon");
                  window.history.pushState({}, "", currentUrl.toString());
                }
              }
            } else {
              setLoadingSnackbar(false);
              setErrorSnackbar(true);
              setBtnDisabled(false);
            }
          })
          .catch((error) => {
            console.log(error);
            setLoadingSnackbar(false);
            setErrorSnackbar(true);
            setBtnDisabled(false);
          });
      })
      .catch((error) => {
        console.log(error);
        setLoadingSnackbar(false);
        setErrorSnackbar(true);
        setBtnDisabled(false);
      });
  };
  const handleLoadingSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setLoadingSnackbar(false);
  };
  const handleSuccessSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSuccessSnackbar(false);
  };
  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setErrorSnackbar(false);
  };

  return (
    <React.Fragment>
      <Snackbar
        open={loadingSnackbar}
        autoHideDuration={3000}
        onClose={handleLoadingSnackbarClose}
      >
        <Alert
          onClose={handleLoadingSnackbarClose}
          severity="info"
        >
          Sending information...
        </Alert>
      </Snackbar>
      <Snackbar
        open={successSnackbar}
        autoHideDuration={3000}
        onClose={handleSuccessSnackbarClose}
      >
        <Alert
          onClose={handleSuccessSnackbarClose}
          severity="success"
        >
          Thanks, {name}! We&apos;ll get in touch shortly.
        </Alert>
      </Snackbar>
      <Snackbar
        open={errorSnackbar}
        autoHideDuration={3000}
        onClose={handleErrorSnackbarClose}
      >
        <Alert
          onClose={handleErrorSnackbarClose}
          severity="error"
        >
          Oops! Something has gone wrong! Please try again.
        </Alert>
      </Snackbar>
      <Paper
        elevation={3}
        className={classes.contactPaper}
      >
        <form
          id="cf"
          className={classes.contactForm}
          method="GET"
        >
          {/* <div className={classes.textforms}> */}
          <TextField
            id="name"
            name="name"
            label="Name"
            required={true}
            type="text"
            autoComplete="off"
            className={classes.textField}
            onChange={(event) => {
              const value = event.target.value.replace(/[^A-Za-z\s.]/g, "");
              setName(value);
            }}
            value={name}
            variant="outlined"
            inputProps={{
              maxLength: 50,
              pattern: "[A-Za-z\\s.]*",
            }}
            InputProps={{
              style: {
                borderRadius: "16px",
              },
            }}
          />
          <label htmlFor="name"></label>
          {/* <TextField
            id="phone"
            name="phone"
            label="Phone"
            required={true}
            autoComplete="off"
            type="tel"
            className={classes.textField}
            value={phone}
            onChange={(event) => {
              const value = event.target.value.replace(/\D/g, "");
              if (value.length <= 10) {
                setPhone(value);
              }
            }}
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }}
            variant="outlined"
            error={phone !== "" && !phone.match(/^[6-9]\d{9}$/)}
            helperText={
              phone !== "" && !phone.match(/^[6-9]\d{9}$/) ? "Please enter a valid 10-digit mobile number" : ""
            }
            InputProps={{
              inputMode: "numeric",
              maxLength: 10,
              style: {
                borderRadius: "16px",
              },
            }}
          />
          <label htmlFor="phone"></label> */}
          <div className={classes.phoneContainer}>
            <Select
              value={countryCode}
              onChange={(event) => {
                setCountryCode(event.target.value);
                setPhone(""); // Clear phone when country changes
              }}
              variant="outlined"
              className={classes.countryCode}
              style={{
                borderRadius: "1rem",
              }}
            >
              <MenuItem value="+91">🇮🇳 +91</MenuItem>
              <MenuItem value="+65">🇸🇬 +65</MenuItem>
              <MenuItem value="+971">🇦🇪 +971</MenuItem>
              <MenuItem value="+1">🇺🇸 +1</MenuItem>
            </Select>
            <TextField
              id="phone"
              name="phone"
              label="Phone"
              required={true}
              autoComplete="off"
              type="tel"
              value={phone}
              className={classes.phoneInput}
              onChange={(event) => {
                const value = event.target.value.replace(/\D/g, "");
                if (value.length <= phonePatterns[countryCode].maxLength) {
                  setPhone(value);
                }
              }}
              variant="outlined"
              error={phone !== "" && !validatePhone(phone)}
              helperText={phone !== "" && !validatePhone(phone) ? getErrorText() : ""}
              InputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
                style: {
                  borderRadius: "16px",
                },
              }}
            />
          </div>
          {/* </div> */}
          <TextField
            id="email"
            name="email"
            label="Email"
            type="email"
            required={true}
            autoComplete="off"
            className={classes.textField}
            onChange={(event) => {
              setEmail(event.target.value);
            }}
            value={email}
            variant="outlined"
            error={email !== "" && !email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i)}
            helperText={
              email !== "" && !email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i)
                ? "Please enter a valid email address"
                : ""
            }
            InputProps={{
              style: {
                borderRadius: "16px",
              },
            }}
          />
          <label htmlFor="email"></label>
          {/* <TextField
            id="message"
            name="message"
            label="Message"
            type="text"
            multiline={true}
            autoComplete="off"
            rows={4}
            className={classes.textField}
            onChange={(event) => {
              setMessage(event.target.value);
            }}
            variant="outlined"
            InputProps={{
              style: {
                borderRadius: "16px",
              },
            }}
          />
          <label htmlFor="message"></label> */}
          <input
            id="source"
            type="hidden"
            name="source"
            value={props.source}
            onChange={(event) => {
              setSource(event.target.value);
            }}
          />
          <div className={classes.checkboxRow}>
            <FormControlLabel
              style={{ alignItems: "flex-start" }}
              control={
                <Checkbox
                  style={{ padding: "0rem 0.5rem 0rem 0rem" }}
                  checked={atc}
                  onChange={(event) => {
                    setAtc(atc === true ? false : true);
                  }}
                  color="primary"
                  value={atc}
                  name="agree"
                />
              }
              label={
                <span>
                  <Link
                    href="/terms"
                    target="_blank"
                    aria-label="Terms of Service"
                    title="Terms of Service"
                    rel="noopener"
                    className={classes.grey}
                  >
                    Terms of Service {""}
                  </Link>
                  <span className={classes.grey}>and</span>{" "}
                  <Link
                    href="/privacy"
                    target="_blank"
                    aria-label="Privacy Policy"
                    title="Privacy Policy"
                    rel="noopener"
                    className={classes.grey}
                  >
                    Privacy Policy.
                  </Link>
                </span>
              }
            />
          </div>
          <div className={classes.btnRow}>
            <Button
              variant="outlined"
              title="Submit"
              onClick={submitForm}
              disabled={btnDisabled}
              rel="noopener"
              className={classes.primaryButton}
            >
              Submit
            </Button>
          </div>
        </form>
      </Paper>
    </React.Fragment>
  );
};

export default ContactForm;
